import { useLocation } from 'react-router-dom';
import React, { createContext, useContext, useState, useCallback } from 'react';

const SearchContext = createContext();

export function useSearch() {
    const context = useContext(SearchContext);
    const { pathname } = useLocation();
    const updateSearchTerm = useCallback(term => context.updateSearchTerm(term, pathname), [context.updateSearchTerm, pathname]);
    const searchTerm = context.pathname === pathname ? context.searchTerm : '';
    return {
        searchTerm,
        searchIsCleaned: searchTerm === '',
        updateSearchTerm
    };
}

export const SearchProvider = ({ children }) => {
    // Now we will use an object to hold the search term and the clean state.
    const [searchAttributes, setSearchAttributes] = useState({
        pathname: null,
        searchTerm: '',
        searchIsCleaned: true
    });

    // Function to update both the search term and the clean indicator.
    const updateSearchTerm = useCallback((term, pathname) => {
        setSearchAttributes({
            pathname,
            searchTerm: term.trim(),
            searchIsCleaned: term.trim() === ''  // True if the term is empty
        });
    }, []);

    return (
        <SearchContext.Provider value={{ ...searchAttributes, updateSearchTerm }}>
            {children}
        </SearchContext.Provider>
    );
};
